export const PROGRESS = {
    ACTIVE: 'ACTIVE',
    COMPLETE: 'COMPLETE',
    INCOMPLETE: 'INCOMPLETE'
} as const;

export type ProgressState = keyof typeof PROGRESS;
